
import { ApiProperty } from '@nestjs/swagger'

/**
 * Ressource simplifiée retournée par le batch
 */
export interface ResourceBatchItem {
  id: string
  title: string | null
  description: string | null
  type: string
  url: string
}

/**
 * DTO pour la réponse batch de ressources
 */
export class GetResourcesBatchResponseDto {
  @ApiProperty({
    description: 'Ressources récupérées',
    type: 'array',
    items: {
      type: 'object',
      properties: {
        id: { type: 'string' },
        title: { type: 'string', nullable: true },
        description: { type: 'string', nullable: true },
        type: { type: 'string' },
        url: { type: 'string' },
      },
    },
  })
  resources!: ResourceBatchItem[]
}
